export default {
  toasts: {
    printing: 'A imprimir...',
    print_failed: 'Falha na impressão. Tente novamente',
    orders: {
      print_one: 'A imprimir {{count}} recibo: Encomenda <strong>#{{orderNumber}}</strong>...',
      print_other: 'A imprimir {{count}} recibos: Encomenda <strong>#{{orderNumber}}</strong>...',
    },
  },
};
